module.exports = __webpack_public_path__ + "9e0a61377a2289a3800d3f85985dffa4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/wall_items.png
// module id = 552
// module chunks = 0